DOMReady( function(){
  if( document.querySelector('header #abolink #abodropdown') ){
    document.querySelector('header #abolink .linkdropdown').addEventListener( 'click', function (e){
      if( window.matchMedia("(min-width: 992px)").matches ){
        e.preventDefault();
        let abodropdown = this.closest('#abolink');
        abodropdown.querySelector('#abodropdown').style.display='block';
        abodropdown.addEventListener( 'mouseleave', function (e){
          abodropdown.querySelector('#abodropdown').style.display='none';
        });
      }
    });
  }
});

